import { centerable, uploadable } from '../decorators';
import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const videoFileSpec = centerable(uploadable({
  inline: false,
  draggable: true,
  attrs: {
    type: {
      default: 'videoFile'
    },
    duration: {
      default: 0
    },
    url: {
      default: ''
    },
    thumbnailUrl: {
      default: ''
    },
    captions: {
      default: ''
    }
  },
  group: 'block',
  parseDOM: [{
    tag: `.intercom-interblocks-video-file`,
    getAttrs(dom) {
      let anchor = dom.querySelector('a');
      let image = dom.querySelector('img');
      return {
        thumbnailUrl: image.getAttribute('src'),
        url: anchor.getAttribute('href'),
        captions: image.getAttribute('alt') || ''
      };
    }
  }, {
    tag: '.embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-video video',
    getAttrs(dom) {
      let source = dom.querySelector('source');
      return {
        thumbnailUrl: dom.getAttribute('poster'),
        url: source.getAttribute('src'),
        captions: source.getAttribute('alt') || ''
      };
    }
  }],
  toDOM(node) {
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.video}`
    }, ['video', {
      class: 'block-video-file-player',
      controls: 'pause play mute',
      //eslint-disable-line
      poster: node.attrs.thumbnailUrl,
      style: `display: block; width: 100%; height: 100%;`
    }, ['source', {
      src: node.attrs.url,
      alt: node.attrs.captions
    }]]];
  }
}));